import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  'cmn--cmp--vehicle-image-loader': {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
  },
}));

export default useStyles;
